export const getImportanceValue = (value = 0.75): string => {
  if (value === 0) return "Not Important";
  if (value <= 0.25) return "Less Important";
  if (value <= 0.5) return "Moderately Important";
  if (value <= 0.75) return "Important";

  return "Very Important";
};
